export const pluralize = (word, count, suffix='') => {   
    
    if (((word !== undefined) && (word !== '')) && ((count !== null) && (count !== ''))){
        if (count > 1){
            if ((suffix !== undefined) && (suffix !== '')){
                return word + suffix;
            }
            else{
                return word + "s";
            }
        }
        else{
            return word;
        }
    }
    else{
        return null;
    }
    
};

export default pluralize;